import { render } from "./Repositorio.vue?vue&type=template&id=f717ea66&scoped=true"
import script from "./Repositorio.vue?vue&type=script&lang=js"
export * from "./Repositorio.vue?vue&type=script&lang=js"

import "./Repositorio.vue?vue&type=style&index=0&id=f717ea66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f717ea66"]])

export default __exports__